import { useTranslation } from 'react-i18next';

export default function FinalCTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20collage%20with%20curated%20fashion%20items%20artfully%20arranged%20on%20warm%20sand%20colored%20surface%2C%20soft%20natural%20daylight%20from%20above%2C%20editorial%20flat%20lay%20style%2C%20leather%20goods%20and%20natural%20textiles%2C%20gentle%20shadows%2C%20warm%20neutral%20palette%2C%20artistic%20film%20grain%2C%20subtle%20vignette%2C%20modern%20boutique%20catalog&width=1600&height=800&seq=cta-collage-v2&orientation=landscape"
              alt="Itaobuy prodotti migliori"
              className="w-full object-cover object-top"
            />
          </div>

          <div className="text-center">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-snug mb-8">
              <span className="font-bold">{t('cta.title')}</span>
            </h2>
            <p className="text-base text-foreground-500 leading-relaxed max-w-xl mx-auto mb-10">
              {t('cta.description')}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-10 py-3.5 rounded-full font-label text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap min-w-[220px]"
              >
                {t('cta.button_primary')}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 border border-foreground-300 text-foreground-800 px-10 py-3.5 rounded-full font-label text-sm hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all cursor-pointer whitespace-nowrap min-w-[220px]"
              >
                {t('cta.button_secondary')}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}